import BatteryModal from "./BatteryModal";

export default BatteryModal;